import { useMutation } from '@tanstack/react-query'

import * as api from '../api'
import useInvalidate from '../useInvalidate'

export default function useDeleteAsset() {
  const invalidate = useInvalidate()

  return useMutation({
    mutationFn: async ({ learningItemUuid, assetUuid }: { learningItemUuid: string; assetUuid: string }) => {
      await api.del(`course/${encodeURIComponent(learningItemUuid)}/asset/${encodeURIComponent(assetUuid)}`, {})
      invalidate.assets()
    },
  })
}
